/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import { useContext, useEffect, useState } from 'react';
import { MessageType } from 'react-idle-timer';
import ChatsContext from '../../../../contexts/chats/context';
import { IMessageHeader } from './types';
import AuthContext from '../../../../contexts/auth/context';
import ContactInfoArea from '../../../Messages/ChatMessage/ContactInfoArea';

export const MessageHeaderUserInfo = ({ itemMsg, isbot, isAnotation }: IMessageHeader) => {
  const { basicContactInfo, discussionOpened, serviceSelected } = useContext(ChatsContext);
  const { currentUser, currentUserInfo } = useContext(AuthContext);
  const [name, setName] = useState('');

  useEffect(() => {
    let headerName = '';
    if (isAnotation && itemMsg.transferData && itemMsg.transferData?.transferredBy) {
      headerName = itemMsg.transferData?.transferredBy?.name;
    } else if (!discussionOpened && itemMsg.userId === currentUser.userId) {
      headerName = currentUserInfo.name;
    } else if (!basicContactInfo || basicContactInfo?._id === itemMsg?.u?._id) {
      if (basicContactInfo && serviceSelected?.v?._id === basicContactInfo._id) {
        headerName = basicContactInfo.name;
      } else {
        const nameKey = ['name', 'username', 'from'].find(
          (key) => itemMsg[key as keyof MessageType]
        ) as keyof MessageType;

        headerName = nameKey ? itemMsg[nameKey] : itemMsg.u.name;
      }
    } else {
      headerName = itemMsg.from;
    }
    setName(headerName);
  }, [
    basicContactInfo,
    currentUser.userId,
    currentUserInfo.name,
    discussionOpened,
    isAnotation,
    itemMsg,
    serviceSelected?.v?._id,
  ]);

  return <ContactInfoArea name={name} authorRole={isbot ? 'bot' : 'agent'} />;
};
